export const global = store => store.global.loading;
export const logoutModal = store => store.global.logoutModal;
